import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './sportlink.action';

@Injectable({ providedIn: 'root' })
export class SportlinkTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '',
                sportlink_synced_at: '',
                id: '',
                debtor_name: '',
                club_name: '',
                outstanding_status: null,
                outstanding_with_fee: '',
                dossier_categories_name: null
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at'; //season_name
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    clubId = 0;
    
    statuses = [
        {id: "0", value: "DOSSIER.pending"},
        {id: "1", value: "DOSSIER.paid"},
        {id: "2", value: "DOSSIER.uncollectable"},
    ];

    outstandings = [
        {"id": "1", "name": "COMMON.yes"},
        {"id": "0", "name": "COMMON.no"}
    ];
    
    columns = [
                { prop: 'id', name: 'COMMON.id', sortable: true, hasFilter: true, filter: "input", widthSet: 70},
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 145},
                { prop: 'sportlink_synced_at', name: 'SPORTLINK.last-synced-at', sortable: true, hasFilter: true, filter: "date", widthSet: 145},
                { prop: 'debtor_name', name: 'SPORTLINK.debtor-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'club_name', name: 'SPORTLINK.club', sortable: true, hasFilter: true, filter: "input", widthSet: 240},
                { prop: 'outstanding_status', name: 'SPORTLINK.outstanding', sortable: true, hasFilter: true, filter: "select", options: 'outstandings', options_id: "id", options_label: "name" , widthSet: 160},
                { prop: 'outstanding_with_fee', name: 'SPORTLINK.amount', sortable: true, hasFilter: true, filter: "input", widthSet: 110}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;         
    }

    resetState(){
        this.filters = {
            created_at: '',
            sportlink_synced_at: '',
            id: '',
            debtor_name: '',
            club_name: '',
            outstanding_status: null,
            outstanding_with_fee: '',
            dossier_categories_name: null
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}